export const roadmapData = [
  {
    phase: "Blueprint Q4-24",
    date: "1",
    avatar: "/icons/fire.svg",
    items: [
      "Game Development: We kick off the core development of the Rumble game, focusing on creating the foundational mechanics of the knockout tournament, opponent selection, and elemental battles.",
      "Art Design & Character Creation: Bringing each elemental character to life with unique designs and styles that capture the essence of Rumble's four elements.",
      "Launch the Collection (4096 NFTs): The tide is rising, and Rumble champions are ready. The official mint begins, bringing our elemental warriors into the hands of their masters."
    ],
  },
  {
    phase: "The Battlefront Q1-25",
    date: "2",
    avatar: "/icons/water.svg",
    items: [
      "Partnerships with Gaming Communities: We'll establish partnerships with leading Web3 gaming communities, influencers, and platforms to expand our reach and bring like-minded players and NFT enthusiasts into the Rumble ecosystem.",
      "Launch the Collection (4096 NFTs): The tide is rising, and Rumble champions are ready. The official mint begins, bringing our elemental warriors into the hands of their masters.",
      "Knockout tournament begins: The elemental forces clash in our first official tournament."
    ],
  },
  {
    phase: "Expansion Q2-25",
    date: "3",
    avatar: "/icons/earth.svg",
    items: [
      "Funding Phase: Increase the prize pool, enhancing rewards and creating a larger, more competitive ecosystem for Web3 Communities",
      "Sidekick Free Mint: Introduce collectible sidekick companions to enhance player strategy.",
      "PVP Battle for NFT Holders: A new one-on-one battle system where Rumble NFT holders can challenge each other and wager funds. Each duel's outcome is influenced by NFT elemental strengths, adding strategic depth and rewarding skillful play."
    ],
  },
  {
    phase: "New World Q2-25",
    date: "4",
    avatar: "/icons/wind.svg",
    items: [
      "Season 2 Launch: Introduce bigger prizes, new characters and challenges for a fresh game experience.",
      "Community Event: Host a large-scale event with giveaways and community-building activities."
    ],
  }
];
